module.exports = __webpack_public_path__ + "img/image-5.951cc235.jpg";